import { useEffect, useState } from 'react'

import MapCountryModalStudent from './MapCountryModalStudent'
import Icon from '../../../../components/UI/Icon'

import { useOutsideClick } from '../../../../hooks'

const pageSize = 4

const MapCountryModal = ({ students, country, onClose }) => {
  const [page, setPage] = useState(1)

  const pages = Math.ceil(students.length / pageSize)

  const modalRef = useOutsideClick(onClose)

  const handlePrevPage = () => {
    setPage((prevState) => {
      if (prevState === 1) {
        return prevState
      }

      return prevState - 1
    })
  }

  const handleNextPage = () => {
    setPage((prevState) => {
      if (prevState === pages) {
        return prevState
      }

      return prevState + 1
    })
  }

  useEffect(() => {
    if (modalRef.current) {
      modalRef.current?.scrollIntoView({
        inline: 'center',
        block: 'center',
      })
    }
  }, [])

  const studentsContent = students.slice(0, pageSize).map((student) => {
    return <MapCountryModalStudent key={student.id || student.first_name} student={student} />
  })

  return (
    <div
      ref={modalRef}
      className="animate-appear absolute z-[1] top-[24px] w-[428px] rounded-[10px] shadow-map-dialog bg-[#FEEBDD] border-[#FFCA84] border-[1px] px-[18px] py-[12px]"
    >
      <h3 className="text-[#F67443] font-bold text-base font-Inter mb-[16px]">
        Your Students From {country.printable_name}
      </h3>

      <div className="w-full flex flex-col gap-y-[12px]">{studentsContent}</div>

      <div className="w-full mt-[24px] flex items-center justify-center">
        <button onClick={handlePrevPage}>
          <Icon name="arrow-right-space" color="#F67443" className="w-[20px] h-[20px] rotate-180" />
        </button>

        <span className="text-sm font-medium text-[#F67443] font-Inter mx-[5px]">
          {page}/{pages}
        </span>

        <button onClick={handleNextPage}>
          <Icon name="arrow-right-space" color="#F67443" className="w-[20px] h-[20px]" />
        </button>
      </div>
    </div>
  )
}

export default MapCountryModal
